module.exports = __webpack_public_path__ + "static/img/flag-mb.1f125bec.png";